/**
 * Styled Components - Created by david on 12/02/18.
 */
import Icon from 'antd/lib/icon'
import Popover from 'antd/lib/popover'
import styled from 'styled-components'
import { BLACK, GRAY_DARK, RED, WHITE } from '../../theme/colors'

type StyledProps = {
  backgroundColor?: string
  showTooltips?: boolean
  isHovered?: boolean
  archived?: boolean
  withBorder?: boolean
  withMargin?: boolean
  selected?: boolean
}

export const Container = styled.div`
   list-style: none;
   display: inline-block;
   width: 237px;
   min-width: calc(100% / 4);
   margin-bottom: 25px;
   padding: 0px 4px;
   position: relative;
 `

export const Footer = styled.div`
  padding: 2px 10px;
  font-family: Avenir;
 `

export const DiscontinuedLabel = styled.div`
  background: #e17889;
  padding: 4px 8px;
  font-size: 10px;
  position: absolute;
  z-index: 10;
  right: ${({ archived }: StyledProps) => archived ? '74px' : '11px'};
  top: -9px;
  color: ${WHITE};
  border-radius: 25px;
`

export const ArchivedLabel = styled.div`
  position: absolute;
  z-index: 10;
  right: 11px;
  border-radius: 25px;
  padding: 4px 8px;
  background: #c6c6c6;
  font-size: 10px;
  color: white;
  top: -9px;
`

export const QuickView = styled.img``

export const Type = styled.div`
   color: ${BLACK};
   font-size: 14px;
   line-height: 19px;
   overflow: hidden;
   text-overflow: ellipsis;
   width: 100%;
   display: flex;
   justify-content: space-between;
   align-items: flex-start;
   @media (min-width: 320px) and (max-width: 480px) {
     width: 100%;
   }
 `

export const CodeLabel = styled.div`
  color: ${BLACK}
  font-size: 12px;
  font-weight: bold;
  line-height: 16px;
  padding 2px 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const Description = styled.div`
   user-select: none;
   color: #8c8c8c;
   font-size: 12px;
   line-height: 16px;
   padding 2px 0px;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   width: 220px;
 
   @media (min-width: 320px) and (max-width: 480px) {
     width: 100%;
   }
 `

export const InfoContainer = styled.div`
   user-select: none;
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   margin-top: 2px;
   margin-left: 2px;
 `

export const Date = styled.div`
   user-select: none;
   color: #5f6062;
   font-size: 12px;
   line-height: 16px;
 `

export const StatusFlag = styled.img`
  position: absolute;
  height: 50px;
  right: 8px;
  top: 4px;
  z-index: 8;
  ${({ showTooltips }: StyledProps) => showTooltips ? `
    animation: pulse 2s 2s infinite;
    @keyframes pulse {
      0% {
        transform: scale(0.95);
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 1));
      }
    
      70% {
        transform: scale(1);
        filter: drop-shadow(0 0 10px rgba(255, 0, 0, 0));
      }
    
      100% {
        transform: scale(0.95);
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 0));
      }
    }
  ` : ''}
`

export const StyledTooltip = styled(Popover)``

export const TooltipContent = styled.div`
  max-width: 398px;
`

export const StatusIcon = styled.img`
  float: right;
  max-width: 78px;
  margin-left: 8px;
`

export const TooltipBody = styled.div`
  padding-top: 16px;
  padding-left: 8px;
  padding-right: 10px;
  @media (max-width: 767px) {
    padding-top: 30px;
    padding-left: 19px;
    padding-right: 17px;
  }
`

export const TooltipContentModal = styled.div`
  max-width: 398px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const buttonStyle = {
  boxShadow: 'none',
  border: 'none',
  background: 'none',
  color: RED
}

export const SpecialNote = styled.div`
  color: ${RED};
  font-size: 13px;
`

export const MenIcon = styled(Icon)`
  color: #2196f3;
`
export const WomenIcon = styled(Icon)`
  color: deeppink;
`

export const GendersContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 4px;
  margin-top: 1px;
`

export const RetailColors = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`

export const ImgIcon = styled.img`
  height: 15px;
  margin-right: 5px;
  width: 15px;
  border-radius: 50%;
  ${({ withBorder }: StyledProps) => (withBorder ? 'border: 1px solid' : '')};
`

export const ColorOption = styled.div`
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 18px;
  padding: 0px 9px;
  margin-right: 10px;
  transition: all .25s;
`

interface DivProps {
  secondary?: boolean
}

export const ColorName = styled.div`
  z-index: 2;
  color: #b0b0b0;
  font-size: 10px;
  mix-blend-mode: difference;
  white-space: nowrap;
  ${({ secondary }: DivProps) => secondary ? `
    color: ${WHITE};
    mix-blend-mode: unset;
  ` : ''};
`

export const ProductAvailableColor = styled.img`
  position: absolute;
  z-index: 1;
  object-fit: cover;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 25px;
  transition: all .25s;
  border: ${({ selected, withBorder }: StyledProps) =>
    selected
      ? `2px solid #ff99a9`
      : (withBorder ? `1px solid ${GRAY_DARK}` : 'none')};
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProductThumbnailInline/styledComponents.tsx